import React from 'react'
import { MapContentProps } from '../types'

import { AdvancedMarker, Pin } from '@vis.gl/react-google-maps'
import { COLORS_MAP } from './styles'
import { useAutoBounds } from '../hooks/useAutoBounds'
import { usePolyline } from '../hooks/usePolyline'

function MapContent({ checkpoints }: MapContentProps) {
  useAutoBounds(checkpoints)
  usePolyline(checkpoints)

  return (
    <>
      {checkpoints.map((checkpoint) => (
        <AdvancedMarker
          key={`${checkpoint.coord.lat}-${checkpoint.coord.lng}`}
          position={checkpoint.coord}
        >
          <Pin
            background={COLORS_MAP[checkpoint.status]}
            glyphColor={'#FFF'}
            borderColor={'#000'}
          />
        </AdvancedMarker>
      ))}
    </>
  )
}

export default MapContent
